

































import { Component, Vue } from "vue-property-decorator";

/**
 * Utils
 */

import { teamUrl } from "@/utils/url-helpers";

/**
 * Mixins
 */

/**
 * Components
 */
import TeamCard from "./components/TeamCard.vue";

/**
 * API
 */
import teamsAPI from "@/api/teams";
import { GetOneTeamPublicResponse } from "@/api/teams/get-one-team-public.response";
import DataFetcher from "@/components/_global/DataFetcher.vue";


/**
 * Types
 */

/**
 * VueX Modules
 */


@Component({
	components: {
		DataFetcher,
		TeamCard
	}
})
export default class InviteTeamPage extends Vue {
	/// Injections
	teamUrl = teamUrl;

	/// Attributes
	isLoading = false;
	teamPublicInfos: GetOneTeamPublicResponse | null = null;

	/// Methods
	async created() {
	}

	async fetch() {
		const inviteCode = this.$route.params.inviteCode;
		this.teamPublicInfos = await teamsAPI.getPublicTeamInfos(inviteCode);

		try {
			// Test if the current user has access to the team, then redirect to the dashboard
			await this.tryRedirectToTeamPage();
		} catch (error) {
			// Otherwise, it's a classic invite
		}
	}

	async handleAcceptInvite() {
		this.isLoading = true;
		try {
			const inviteCode = this.$route.params.inviteCode;
			await teamsAPI.acceptInviteCode(inviteCode);
			await this.tryRedirectToTeamPage();
		} catch (err) {
			this.handleAPIError(err);
			this.isLoading = false;
		}
	}

	async tryRedirectToTeamPage() {
		if (this.teamPublicInfos == null) {
			return;
		}

		const teamInfos = await teamsAPI.getTeamInfos(this.teamPublicInfos.id);
		await this.$router.push(teamUrl(teamInfos, "/"));
	}

}
